/**
 * evGlows™ - Central Bilingual Translation Dictionary (ES / EN)
 * Zero-App Architecture - High-Converting CRO Copywriting (PAS Formula)
 */
(function() {
  window.evglowsTranslations = {
    es: {
      // Announcement Bar
      announcement: {
        urgent: "OFERTA FLASH TERMINA EN:",
        perk: "🎁 Control Remoto RF de Regalo",
        discount: "• Hasta 46% DTO"
      },
      // Header & Navigation
      nav: {
        track: "Rastrear Pedido",
        contact: "Contacto",
        buy: "Elegir Pack evGlows™",
        dark: "OSCURO",
        light: "CLARO",
        home: "Inicio"
      },
      // Modals
      modal_track: {
        title: "Rastrea tu Pedido",
        subtitle: "Seguimiento logístico en tiempo real",
        desc: "Introduce el número de seguimiento recibido en tu email de confirmación para localizar tu envío:",
        placeholder: "Ej: ES294819483 o GLOW-1042",
        btn: "Localizar Envío",
        couriers: "Transportistas oficiales integrados:"
      },
      modal_contact: {
        title: "Atención al Cliente",
        subtitle: "Canal directo de asistencia oficial",
        email_title: "✉️ Email de Soporte Oficial",
        email_note: "Respuesta garantizada en menos de 24 horas.",
        hours_title: "⏰ Horario de Atención",
        hours_val: "Lunes a Viernes: 9:00 - 19:00 (Hora Peninsular)",
        hours_note: "Soporte continuo para incidencias en envíos activos.",
        guarantee_title: "🛡️ Compromiso Total evGlows™",
        guarantee_val: "Garantía de 30 días con reemplazo directo ante cualquier defecto de fábrica sin coste adicional.",
        btn: "Escribir a Soporte"
      },
      // Trust Strip
      trust: {
        free_shipping: "Envío Gratis",
        shipping_sub: "Asegurado",
        rating: "4.7 / 5.0 Estrellas",
        rating_sub: "+2.400 clientes contentos",
        guarantee: "Garantía 30 Días",
        guarantee_sub: "100% garantizado",
        payment: "Pago Seguro",
        payment_sub: "Apple Pay, GPay, Tarjeta"
      },
      // Sticky Floating Bar
      sticky: {
        choose: "Elegir",
        choose_desktop: "Elegir Pack",
        buy: "Comprar",
        buy_desktop: "Comprar Ahora",
        scroll_top: "Subir al inicio",
        priority: "Envío Prioritario Asegurado",
        discount: "50% DTO"
      },
      // Hero Product & Bundles
      hero: {
        badge: "HARDWARE LED AUTOMOTRIZ N°1 EN VENTAS",
        title: "evGlows™ Pantalla LED Flexible Inteligente",
        subtitle: "Personaliza la luna trasera de tu coche, escaparate o habitación en segundos. Control total desde tu móvil vía Bluetooth: cientos de animaciones, modo Devil Eyes, textos personalizados y sincronización musical.",
        stock_warning: "¡Alta Demanda! Solo quedan 6 unidades disponibles con envío prioritario.",
        selector_title: "ELIGE TU PACK CON HASTA 50% DTO:",
        most_popular: "MÁS POPULAR",
        best_value: "MEJOR VALOR",
        add_to_cart: "COMPRAR AHORA CON 50% DTO →",
        free_shipping_notice: "🚚 Envío Exprés Asegurado con Seguimiento Incluido",
        ssl_badge: "Pago Seguro con Encriptación SSL 256-bit",
        payment_accepted: "Pago Seguro Aceptado",
        faq_title: "Preguntas Frecuentes sobre evGlows™",
        faq1_q: "¿Cómo se conecta y necesita instalación complicada?",
        faq1_a: "No requiere ninguna instalación complicada ni tocar cables. Se conecta directamente por USB a cualquier puerto 5V (vehículo, powerbank o adaptador). Incluye cable largo de 5 metros para guiarlo fácilmente. Es 100% Plug & Play.",
        faq2_q: "¿Se ve a través de cristales tintados?",
        faq2_a: "Sí. Cuenta con LEDs RGB de alta densidad y 1.200 nits de brillo regulable, garantizando máxima visibilidad incluso a través de lunas tintadas homologadas u oscuras.",
        faq3_q: "¿Qué incluye el paquete?",
        faq3_a: "Incluye el panel flexible evGlows™, cable USB de 5 metros reforzado, mando a distancia inalámbrico, rollo de cinta adhesiva de polímero sin residuos y manual con código QR de la App oficial."
      },
      // Bundles
      bundles: {
        compact: {
          name: "1 Panel Compacto",
          size: "16×32 cm (Ideal lunetas pequeñas)",
          badge: "Básico"
        },
        standard: {
          name: "1 Panel Estándar + Mando",
          size: "16×64 cm (Tamaño Más Vendido)",
          badge: "MÁS POPULAR",
          gift: "Regalo: Mando a distancia inalámbrico (Valorado en 15€)"
        },
        duo: {
          name: "Pack Dúo (2 Paneles + 2 Mandos)",
          size: "2× (16×64 cm) Luneta Doble o Regalo",
          badge: "MEJOR VALOR",
          gift: "Regalo: 2 Mandos + Envío VIP Exprés Prioritario"
        }
      },
      // Video Reels
      reels: {
        badge: "VÍDEOS REALES SIN FILTROS",
        title: "Mira a evGlows™ en Acción en Carretera",
        subtitle: "Graba miradas en cada semáforo. Así luce instalado en coches y furgonetas reales.",
        reel1_tag: "Ojos Diablo",
        reel1_title: "Modo Devil Eyes en Luna Trasera",
        reel2_tag: "Control App",
        reel2_title: "Crea Textos y Emojis en 1 Toque",
        reel3_tag: "Lunas Tintadas",
        reel3_title: "1.200 Nits: Visibilidad Total de Noche"
      },
      // Feature Tabs
      tabs: {
        badge: "MODOS DE PANTALLA INTELIGENTES",
        title: "Una Pantalla, Infinitas Posibilidades",
        subtitle: "Cambia entre animaciones agresivas, mensajes personalizados o ritmo musical desde la app.",
        tab1: "Ojos Diablo (Devil Eyes)",
        tab1_desc: "Más de 40 animaciones exclusivas de miradas agresivas, guiños y patrones dinámicos para tu luna trasera.",
        tab2: "Textos y Cartelería",
        tab2_desc: "Escribe cualquier frase, cambia la tipografía, color y velocidad de scroll. Perfecto para avisos, marcas o diversión.",
        tab3: "Ritmo Musical y Emojis",
        tab3_desc: "El micrófono integrado sincroniza las luces con tu música o reproduce emojis animados en alta resolución."
      },
      // Bento Grid
      bento: {
        badge: "INGENIERÍA Y ESPECIFICACIONES TÉCNICAS",
        title: "Construido para Durar, No para Deslumbrar en Falso",
        subtitle: "Hardware automotriz de grado industrial diseñado para resistir vibraciones, calor y humedad.",
        card1_tag: "ULTRA FLEXIBLE",
        card1_title: "Torsión de 180° Sin Daño",
        card1_desc: "Placa base de resina epoxi de solo 2mm de grosor. Se adapta a curvas pronunciadas de cualquier luna o cristal.",
        card2_tag: "ALTA LUMINOSIDAD",
        card2_title: "1.200 Nits Regulables",
        card2_desc: "Visibilidad perfecta a plena luz del día o graduación suave de noche sin deslumbrar a otros conductores.",
        card3_tag: "PLUG & PLAY",
        card3_title: "Conexión USB Universal 5V",
        card3_desc: "Compatible con mechero, puertos USB del vehículo o cualquier batería externa estándar.",
        card4_tag: "RESISTENCIA TOTAL",
        card4_title: "Protección IP68 Agua y Polvo",
        card4_desc: "Sellado epoxi impermeable. Soporta condensación interna, lavados a presión y variaciones térmicas extremas.",
        card5_tag: "CONTROL BLUETOOTH",
        card5_title: "App Oficial iOS y Android",
        card5_desc: "Sincronización instantánea en menos de 2 segundos. Galería gratuita con actualizaciones mensuales de animaciones.",
        card6_tag: "SIN RESIDUOS",
        card6_title: "Cinta de Polímero Reutilizable",
        card6_desc: "Adhesión firme y retirada limpia sin dejar restos de pegamento en la luna ni dañar las líneas térmicas."
      },
      // Comparison Table
      comparison: {
        badge: "COMPARATIVA DIRECTA",
        title: "evGlows™ vs. Imitaciones Baratas",
        subtitle: "Por qué las alternativas económicas terminan quemándose o despegándose a las 2 semanas.",
        feature_col: "Características",
        ours_col: "evGlows™ Oficial",
        others_col: "Copias Genéricas",
        row1: "Brillo y Nits",
        row1_ours: "1.200 Nits (Se ve con tinte)",
        row1_others: "300 Nits (Invisible de día)",
        row2: "Flexibilidad y Resina",
        row2_ours: "Epoxi Flexible 180° Grado Automotriz",
        row2_others: "Plástico rígido quebradizo",
        row3: "Control Remoto",
        row3_ours: "App Bluetooth + Mando Inalámbrico",
        row3_others: "Solo botones físicos traseros",
        row4: "Cable de Alimentación",
        row4_ours: "5 Metros Ocultable Reforzado",
        row4_others: "1 Metro (Insuficiente para coches)",
        row5: "Adhesivo",
        row5_ours: "Polímero sin pegamento residual",
        row5_others: "Cinta barata que mancha el cristal",
        row6: "Garantía y Soporte",
        row6_ours: "30 Días Devolución + 2 Años Soporte",
        row6_others: "Sin soporte ni garantía en España"
      },
      // Reviews Proof
      reviews: {
        badge: "OPINIONES VERIFICADAS",
        title: "+2.400 Conductores Ya Lo Disfrutan",
        subtitle: "Reseñas reales de clientes con fotos de instalación en coches, furgonetas y locales.",
        score: "4.9",
        score_text: "de 5.0 Estrellas (2.418 valoraciones verificadas)",
        write_review: "Escribir Reseña",
        verified: "Compra Verificada",
        lightbox_prev: "Anterior",
        lightbox_next: "Siguiente"
      },
      // Package Guarantee
      package: {
        title: "Todo lo que recibirás en tu pedido",
        subtitle: "Listo para conectar y funcionar en 60 segundos.",
        item1_title: "1× evGlows™ Display Flexible",
        item1_desc: "Tamaño según tu pack (16x32 o 16x64 cm) con LEDs RGB alta densidad.",
        item2_title: "1× Cable USB 5 Metros",
        item2_desc: "Longitud extra para ocultar el cableado o llegar fácilmente a cualquier toma de corriente.",
        item3_title: "1× Control Remoto Inalámbrico",
        item3_desc: "Incluido GRATIS con los packs estándar y dúo para cambiar animaciones.",
        item4_title: "1× Rollo Cinta Adhesiva Polímero",
        item4_desc: "Firmeza total y retirada limpia sin dejar pegamento en la luna.",
        item5_title: "1× Guía en Español + QR App",
        item5_desc: "Enlace directo a la app oficial para sincronizar en 1 toque.",
        item6_title: "Garantía de 30 Días",
        item6_desc: "Cobertura total contra cualquier defecto y soporte local en España.",
        guarantee_seal: "30 DÍAS GARANTÍA",
        guarantee_tag: "Cero Riesgo para Ti",
        guarantee_title: "Garantía de Satisfacción 100% o Reembolso",
        guarantee_desc: "Queremos que pruebes evGlows™ con total tranquilidad. Si en los primeros 30 días no te deja con la boca abierta, no se adapta a tu luna, cristal o espacio elegido, escríbenos y te devolvemos el 100% de tu dinero sin preguntas ni complicaciones.",
        guarantee_cta: "PEDIR MI PACK CON 50% DTO →"
      },
      // Sticky Mobile CTA
      sticky: {
        choose: "ELEGIR",
        buy: "COMPRAR"
      },
      // Footer
      footer: {
        desc: "evGlows™ es la pantalla LED flexible ultra fina e inteligente. Personaliza cristales, escaparates, vehículos o cualquier espacio con control por App Bluetooth, modo Ojos Diablo y textos en tiempo real.",
        support_label: "✉️ Atención al cliente:",
        nav_title: "Navegación",
        policies_title: "Políticas de la Tienda",
        rights: "Todos los derechos reservados.",
        ssl: "Pago 100% Seguro SSL",
        lang_label: "Idioma / Language:"
      }
    },
    en: {
      // Announcement Bar
      announcement: {
        urgent: "FLASH SALE ENDS IN:",
        perk: "🎁 Free RF Wireless Remote",
        discount: "• Up to 46% OFF"
      },
      // Header & Navigation
      nav: {
        track: "Track Order",
        contact: "Contact",
        buy: "Order evGlows™ Pack",
        dark: "DARK",
        light: "LIGHT",
        home: "Home"
      },
      // Modals
      modal_track: {
        title: "Track Your Order",
        subtitle: "Real-time logistics tracking",
        desc: "Enter the tracking number received in your confirmation email to locate your shipment:",
        placeholder: "Ex: US928491823 or GLOW-1042",
        btn: "Locate Shipment",
        couriers: "Official integrated carriers:"
      },
      modal_contact: {
        title: "Customer Support",
        subtitle: "Direct official assistance channel",
        email_title: "✉️ Official Support Email",
        email_note: "Guaranteed response within 24 hours.",
        hours_title: "⏰ Support Hours",
        hours_val: "Monday to Friday: 9:00 - 19:00 (CET / EST)",
        hours_note: "Continuous support for active transit shipments.",
        guarantee_title: "🛡️ Total evGlows™ Commitment",
        guarantee_val: "30-day warranty with direct replacement for any factory defects at zero additional cost.",
        btn: "Email Support"
      },
      // Trust Strip
      trust: {
        free_shipping: "Free Shipping",
        shipping_sub: "Insured Delivery",
        rating: "4.7 / 5.0 Stars",
        rating_sub: "+2,400 Happy Customers",
        guarantee: "30-Day Guarantee",
        guarantee_sub: "100% Money-Back",
        payment: "Secure Payment",
        payment_sub: "Apple Pay, GPay, Card"
      },
      // Sticky Floating Bar
      sticky: {
        choose: "Choose",
        choose_desktop: "Select Pack",
        buy: "Buy",
        buy_desktop: "Buy Now",
        scroll_top: "Back to top",
        priority: "Priority Insured Shipping",
        discount: "50% OFF"
      },
      // Hero Product & Bundles
      hero: {
        badge: "#1 BEST-SELLING AUTOMOTIVE LED HARDWARE",
        title: "evGlows™ Smart Flexible LED Screen",
        subtitle: "Customize your car's rear window, storefront, or room in seconds. Full smartphone control via Bluetooth: hundreds of presets, Devil Eyes mode, custom scrolling text, and live music equalizer sync.",
        stock_warning: "High Demand! Only 6 units remaining with priority express shipping.",
        selector_title: "SELECT YOUR PACK WITH UP TO 50% OFF:",
        most_popular: "MOST POPULAR",
        best_value: "BEST VALUE",
        add_to_cart: "BUY NOW WITH 50% OFF →",
        free_shipping_notice: "🚚 Fast Express Delivery with Tracking Included",
        ssl_badge: "Secure Checkout with 256-bit SSL Encryption",
        payment_accepted: "Guaranteed Safe Checkout",
        faq_title: "Frequently Asked Questions About evGlows™",
        faq1_q: "How does it connect? Does it require complicated wiring?",
        faq1_a: "No complex wiring or technical installation required. Simply plug into any 5V USB port (vehicle lighter socket, powerbank, or USB outlet). Includes an extra-long 16.4 ft (5m) reinforced cable to easily hide wiring. 100% Plug & Play.",
        faq2_q: "Is it clearly visible through dark tinted windows?",
        faq2_a: "Yes. Engineered with high-density RGB LEDs and 1,200 nits of adjustable brightness, ensuring maximum visibility even through dark privacy tints.",
        faq3_q: "What is included in the package?",
        faq3_a: "Includes the flexible evGlows™ display, 16.4 ft (5m) USB cable, wireless remote control, reusable polymer adhesive tape with zero residue, and official user manual with App QR code."
      },
      // Bundles
      bundles: {
        compact: {
          name: "1 Compact Display",
          size: "6.3×12.6 in / 16×32 cm (Small windows)",
          badge: "Basic"
        },
        standard: {
          name: "1 Standard Display + Remote",
          size: "6.3×25.2 in / 16×64 cm (Best-Seller Size)",
          badge: "MOST POPULAR",
          gift: "Free Gift: Wireless Remote Control ($20 Value)"
        },
        duo: {
          name: "Duo Pack (2 Displays + 2 Remotes)",
          size: "2× (16×64 cm) Double Window or Gift",
          badge: "BEST VALUE",
          gift: "Free Gift: 2 Wireless Remotes + VIP Priority Shipping"
        }
      },
      // Video Reels
      reels: {
        badge: "REAL UNCUT VIDEOS",
        title: "Watch evGlows™ Live On The Road",
        subtitle: "Turn heads at every traffic light. Here is how it looks installed in real vehicles.",
        reel1_tag: "Devil Eyes",
        reel1_title: "Devil Eyes Preset on Rear Window",
        reel2_tag: "App Control",
        reel2_title: "Design Text & Emojis in 1 Tap",
        reel3_tag: "Tinted Windows",
        reel3_title: "1,200 Nits: Complete Nighttime Punch"
      },
      // Feature Tabs
      tabs: {
        badge: "SMART DISPLAY MODES",
        title: "One Screen, Endless Possibilities",
        subtitle: "Switch between aggressive animations, custom text banners, and music rhythm directly from the app.",
        tab1: "Devil Eyes Animations",
        tab1_desc: "Over 40 exclusive aggressive eye graphics, winks, and dynamic light patterns tailored for your rear window.",
        tab2: "Custom Text & Banners",
        tab2_desc: "Type any sentence, customize font styles, color palette, and scrolling speed. Perfect for warnings, promos, or car meets.",
        tab3: "Music Rhythm & Emojis",
        tab3_desc: "Built-in sensitive microphone syncs equalizer bars to your favorite beats or loops high-resolution animated emojis."
      },
      // Bento Grid
      bento: {
        badge: "ENGINEERING & TECHNICAL SPECIFICATIONS",
        title: "Built to Endure, Not Cheap Plastic Novelties",
        subtitle: "Industrial automotive-grade hardware designed to withstand constant vibration, extreme heat, and humidity.",
        card1_tag: "ULTRA FLEXIBLE",
        card1_title: "180° Bending Without Damage",
        card1_desc: "2mm ultra-thin flexible polymer base. Effortlessly adapts to curved rear windshields and irregular glass.",
        card2_tag: "HIGH BRIGHTNESS",
        card2_title: "1,200 Adjustable Nits",
        card2_desc: "Crystal-clear daylight visibility or smooth nighttime dimming so you never blind drivers behind you.",
        card3_tag: "PLUG & PLAY",
        card3_title: "Universal 5V USB Connection",
        card3_desc: "Powered via car cigarette lighter adapter, vehicle USB ports, or any portable power bank.",
        card4_tag: "WEATHERPROOF",
        card4_title: "IP68 Dust & Water Protection",
        card4_desc: "Epoxy sealed surface. Resists inside condensation, high-pressure car washes, and temperature spikes.",
        card5_tag: "BLUETOOTH CONTROL",
        card5_title: "Official iOS & Android App",
        card5_desc: "Instant pairing in under 2 seconds. Free library with monthly updates of fresh animations and graphics.",
        card6_tag: "NO RESIDUE",
        card6_title: "Reusable Polymer Tape",
        card6_desc: "Rock-solid hold with residue-free removal. Protects defroster grid lines and window tint films."
      },
      // Comparison Table
      comparison: {
        badge: "DIRECT BENCHMARK",
        title: "evGlows™ vs. Cheap Imitations",
        subtitle: "Why knockoffs burn out or unstick within two weeks of exposure.",
        feature_col: "Features",
        ours_col: "evGlows™ Official",
        others_col: "Generic Copies",
        row1: "Brightness & Nits",
        row1_ours: "1,200 Nits (Visible through tints)",
        row1_others: "300 Nits (Invisible in daylight)",
        row2: "Flexibility & Base",
        row2_ours: "180° Automotive Epoxy Bendable",
        row2_others: "Brittle rigid plastic boards",
        row3: "Remote Control",
        row3_ours: "Bluetooth App + Wireless Remote",
        row3_others: "Only tiny back physical buttons",
        row4: "Power Cord Length",
        row4_ours: "16.4 ft (5m) Reinforced Cable",
        row4_others: "3 ft (1m) (Too short for cars)",
        row5: "Adhesive Tape",
        row5_ours: "Residue-Free Clean Polymer",
        row5_others: "Cheap glue that stains windshield",
        row6: "Warranty & Support",
        row6_ours: "30-Day Money-Back + 2-Year Support",
        row6_others: "No warranty or customer service"
      },
      // Reviews Proof
      reviews: {
        badge: "VERIFIED REVIEWS",
        title: "+2,400 Customers Already Loving It",
        subtitle: "Real verified buyer photos from cars, trucks, vans, and gaming setups.",
        score: "4.9",
        score_text: "out of 5.0 Stars (2,418 verified ratings)",
        write_review: "Write a Review",
        verified: "Verified Buyer",
        lightbox_prev: "Previous",
        lightbox_next: "Next"
      },
      // Package Guarantee
      package: {
        title: "Everything You Get in Your Box",
        subtitle: "Ready to plug in and light up in under 60 seconds.",
        item1_title: "1× evGlows™ Flexible LED Display",
        item1_desc: "Size chosen in your pack with ultra-high density RGB LEDs.",
        item2_title: "1× 16.4 ft (5m) USB Power Cable",
        item2_desc: "Extra length to cleanly route and hide wires anywhere in your vehicle.",
        item3_title: "1× Wireless Remote Control",
        item3_desc: "Included FREE with Standard and Duo packs to switch graphics on the fly.",
        item4_title: "1× Roll Polymer Adhesive Tape",
        item4_desc: "Maximum grip and clean peel with zero sticky residue on window glass.",
        item5_title: "1× Official Manual + App QR",
        item5_desc: "Quick start guide with direct download link for iOS and Android.",
        item6_title: "30-Day Money-Back Guarantee",
        item6_desc: "Full coverage against any defects with dedicated responsive support.",
        guarantee_seal: "30-DAY GUARANTEE",
        guarantee_tag: "Zero Risk for You",
        guarantee_title: "100% Satisfaction or Full Refund",
        guarantee_desc: "We want you to try evGlows™ with complete peace of mind. If within the first 30 days you are not completely blown away, write to us and we will refund 100% of your money. No hassle, no questions asked.",
        guarantee_cta: "CLAIM MY PACK WITH 50% OFF →"
      },
      // Sticky Mobile CTA
      sticky: {
        choose: "CHOOSE",
        buy: "BUY NOW"
      },
      // Footer
      footer: {
        desc: "evGlows™ is the ultimate ultra-thin smart flexible LED screen. Personalize windshields, storefronts, vehicles, and rooms with Bluetooth App control, Devil Eyes presets, and real-time custom banners.",
        support_label: "✉️ Customer Support:",
        nav_title: "Navigation",
        policies_title: "Store Policies",
        rights: "All rights reserved.",
        ssl: "100% Secure SSL Checkout",
        lang_label: "Idioma / Language:"
      }
    }
  };

  // Image Mapping Helper (Returns appropriate localized image based on active language)
  window.evglowsImages = {
    hero_main: {
      es: './assets/1_esp.png',
      en: './assets/1_eng.png'
    },
    hero_plug: {
      es: './assets/3_esp.jpg',
      en: './assets/3_eng.jpg'
    },
    hero_waterproof: {
      es: './assets/5_esp.jpg',
      en: './assets/5_eng.jpg'
    },
    hero_eyes: {
      es: './assets/8_esp.jpg',
      en: './assets/8_eng.jpg'
    },
    hero_marquee: {
      es: './assets/9_esp.jpg',
      en: './assets/9_eng.jpg'
    },
    hero_package: {
      es: './assets/11_esp.jpg',
      en: './assets/11_eng.jpg'
    },
    hero_comparison: {
      es: './assets/12_esp.jpg',
      en: './assets/12_eng.jpg'
    }
  };
})();
